import React, { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Container, Image, Row } from "react-bootstrap";
import logo from "../img/logo.png";
import { WalletContext, STAKING_CONTRACT_ID } from "../Wallet";
import * as buffer from "buffer"
  ; window.Buffer = buffer.Buffer

function NavBar() {
  const { wallet, plasmabalance } = useContext(WalletContext)

  const signIn = () => {
    wallet.requestSignIn(STAKING_CONTRACT_ID);
  };

  const signOut = () => {
    wallet.signOut();
    window.location = "/"
  };

  const onWallet = () => {
    if(wallet.isSignedIn()){
      signOut();      
    } else {
      signIn();
    }
  }

  return (
    <Container fluid className="p-2">
      <Row>
        <Col>
          <div className="d-flex gap-3">
            <Image src={logo} height={60} width={60} className="ms-2" />
            {(wallet && wallet.isSignedIn())?
            <ButtonGroup className="ms-auto p-2 info-area">
              <h1 className="ms-2 me-2">{plasmabalance} $PLASMA</h1>
              <Button className="ms-auto" onClick={onWallet} size="lg">{wallet.account().accountId}</Button>
            </ButtonGroup> : <></>}
          </div>
        </Col>
      </Row>
      {(wallet && wallet.isSignedIn())?
        <></> :
        <Row>
          <div className="blank-area">
            <Button className="center-button" onClick={onWallet}>Connect Wallet</Button>
          </div>
        </Row>}
    </Container>
  );
}

export default NavBar;
